import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPlanOption } from '../../services/tournament.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'plan-option',
  templateUrl: 'plan-option.html',
})
export class PlanOptionComponent {
  @Output() public onClick = new EventEmitter();
  @Input() public item: IPlanOption;

  constructor(
    public translateService: TranslateService
  ) { }

}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/components/plan-option/plan-option.ts